<div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap=".5em">
  @if (form) {
    <mg-simple-form [formGroup]="form" [errorMessage]="errorMessage" label="Gebruiker" title="{{item?.firstName}} {{item?.lastName}}" (onSubmit)="onSubmit($event)" (onDelete)="onDelete()" [customActions]="customActions" [dtoClassName]="dtoTypeName">
      <mg-simple-form-section title="Algemeen">
        <mg-simple-form-row>
          <span>
            <mat-form-field pd-size-max-spacer>
              <mat-label>Voornaam</mat-label>
              <input type="text" matInput formControlName="firstName">
              <mat-error>{{getError('firstName')}}</mat-error>
            </mat-form-field>
          </span>
          <span>
            <mat-form-field pd-size-max-spacer>
              <mat-label>Achternaam</mat-label>
              <input type="text" matInput formControlName="lastName">
              <mat-error>{{getError('lastName')}}</mat-error>
            </mat-form-field>
          </span>
          <span>
            <mat-form-field pd-size-max-spacer>
              <mat-label>Email</mat-label>
              <input type="email" matInput formControlName="email">
              <mat-error>{{getError('email')}}</mat-error>
            </mat-form-field>
          </span>
        </mg-simple-form-row>
      </mg-simple-form-section>
      @if (!isNewItem && canCreate('AccessMonitor.Logic.User')) {
        <mg-simple-form-section title="Beveiliging">
          <mg-simple-form-row>
            <span>
              <mat-slide-toggle color="accent" formControlName="locked">Geblokkeerd</mat-slide-toggle>
              <mg-error-icon [error]="getError('locked')"></mg-error-icon>
            </span>
            <span class="wachtwoord-gewijzigd-ruimte"></span>
            <span class="wachtwoord-gewijzigd">
              <mat-form-field>
                <mat-label>Laatste keer wachtwoord gewijzigd</mat-label>
                <input matInput formControlName="lastPasswordChanged" [mgDatetimePickerToggle]="pickerlastPasswordChange" [disabled]="true">
                <mg-datetime-picker-toggle #pickerlastPasswordChange matSuffix [disabled]="true"></mg-datetime-picker-toggle>
              </mat-form-field>
            </span>
          </mg-simple-form-row>
          <br>
            <label class="label-header">Two-Factor Authentication</label>
            <br><br>
            <mg-simple-form-row>
              <span>
                <mat-slide-toggle color="accent" formControlName="mfaEnabled" >Geregistreerd door gebruiker</mat-slide-toggle>
              </span>
            </mg-simple-form-row>
            <mg-simple-form-row>
              <span>
                <mat-slide-toggle color="accent" formControlName="isMfaExempt" >Vrijgesteld van 2FA</mat-slide-toggle>
              </span>
            </mg-simple-form-row>
          </mg-simple-form-section>
        }
      </mg-simple-form>
    }

    <div fxLayout="column" style="float: left;" >
      <mat-tab-group>
        @if (!isNewItem && !isArchived()) {
          <mat-tab>
            <ng-template mat-tab-label>
              <div class="col" style="margin-left: 20px;">Groepen</div>
            </ng-template>
            <mg-subcollection title="Groepen" *mgIfCanRead="'Mango.Authorization.Group'" addable="false">
              <mg-authorization-group-user-collection #collection [user]="this.item"></mg-authorization-group-user-collection>
            </mg-subcollection>
          </mat-tab>
        }

        @if (!isNewItem) {
          <mat-tab>
            <ng-template mat-tab-label>
              <div class="col" style="margin-left: 20px;">Login Historie</div>
            </ng-template>
            <mg-subcollection title="Login Historie" *mgIfCanRead="'Mango.Authentication.UserLoginHistory'" addable="false" deletable="false">
              <user-login-history-collection #collection [user]="item" [defaultPageSize]="20"></user-login-history-collection>
            </mg-subcollection>
          </mat-tab>
        }
        @if (!isNewItem) {
          <mat-tab>
            <ng-template mat-tab-label>
              <div class="col" style="margin-left: 20px;">Rechten</div>
            </ng-template>
            <mg-user-roles-overview *mgIfCanRead="'Mango.Authorization.Role'" [showExplicitProperties]="false" [user]="this.item"></mg-user-roles-overview>
          </mat-tab>
        }
      </mat-tab-group>
    </div>
  </div>